import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d16fda2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cropper-image" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { style: {"width":"600px","height":"600px","margin":"auto"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "radio" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("1:1")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("16:9")
const _hoisted_8 = { style: {"float":"right","padding-right":"100px","line-height":"32px","font-size":"12px"} }
const _hoisted_9 = { class: "el-dialog__body-footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ref, computed, nextTick } from 'vue'
import { Crop, Rank } from '@element-plus/icons-vue'
import { uploadFileApi } from '@/apis/oss'
import 'cropperjs/dist/cropper.css'
import Cropper from 'cropperjs'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: {
  imageRatio: {
    type: Number,
    default: 0
  }
},
  emits: ['submit'],
  setup(__props, { expose, emit }) {

const props = __props


const visible = ref(false)
const imgSrc = ref('')
const aspectRatio = ref(1)
let cropper: any = null
const loading = ref(false)
const saveLoading = ref(false)
const modelType = ref(2)
const open = (src: string) => {
  visible.value = true
  aspectRatio.value = props.imageRatio === 1 ? 1 : 1.77777777
  console.log(props.imageRatio)
  imgSrc.value = src
  nextTick(() => {
    loading.value = true
    draw()
  })
}
const save = () => {
  saveLoading.value = true
  cropper.getCroppedCanvas().toBlob((blob: any) => {
    const file = new window.File([blob], new Date().getTime() + '.png')
    console.log(file)
    var formData = new FormData()
    formData.append('file', file)
    formData.append('path', 'washingMark/')
    uploadFileApi(formData).then((res: any) => {
      saveLoading.value = false
      visible.value = false
      emit(
        'submit',
        'https://' + res.data.data.customDomain + '/' + res.data.data.fileName,
        aspectRatio.value === 1 ? 1 : 2
      )
    }).catch(() => {
      saveLoading.value = false
      ElMessage.error(t('上传失败请重试'))
    })
  })
}

const draw = () => {
  const image: any = document.getElementById('image')
  console.log(image)
  if (!image) return
  cropper = new Cropper(image, {
    aspectRatio: aspectRatio.value,
    dragMode: 'move',
    crop: (event: any) => {
      loading.value = false
    }
  })
}
const changeSize = () => {
  cropper.destroy()
  loading.value = true
  draw()
}
const close = () => {
  visible.value = false
}
const reset = () => {
  cropper.reset()
}
const changeModel = () => {
  cropper.setDragMode(modelType.value === 2 ? 'crop' : 'move')
}
expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "model-value": visible.value,
      "show-close": false,
      width: "800px",
      top: "6vh",
      "destroy-on-close": "",
      onClosed: close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('编辑裁剪图片')), 1),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            referrerPolicy: "no-referrer",
            id: "image",
            src: imgSrc.value,
            style: {"display":"none"}
          }, null, 8, _hoisted_4)
        ], 512), [
          [_directive_loading, loading.value]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_radio_group, {
            modelValue: aspectRatio.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((aspectRatio).value = $event)),
            onChange: changeSize
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                placement: "top",
                effect: "light",
                "hide-after": 30,
                offset: 5,
                content: _unref(t)('适合正方形logo')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, { label: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content"]),
              _createVNode(_component_el_tooltip, {
                placement: "top",
                effect: "light",
                content: _unref(t)('适合长方形logo')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, { label: 1.77777777 }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["content"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('编辑剪切区域和移动图片')), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('重新编辑2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { onClick: close }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: save,
            loading: saveLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})